import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { get } from 'lodash-es';
import { FlashSpreadDocumentData } from 'ng2-app/models/documents/FlashSpreadDocumentData.struct';
import { PusherService } from 'ng2-app/modules/shared/services/pusher.service';
import { FlashSpreadService } from 'ng2-app/services/documents/flashspread.service';
import { GetFlashSpreadData, FlashSpreadPusherSubscribe, ClearFlashSpreadState } from 'ng2-app/store/flashspread/flashspread.actions';
import { catchError, tap } from 'rxjs/operators';

export interface FlashSpreadStateModel {
  loading: boolean;
  borrowerId: number;
  documentsData: Array<FlashSpreadDocumentData>;
}

@State<Partial<FlashSpreadStateModel>>({
  name: 'FlashSpread',
  defaults: {
    documentsData: [],
  }
})
@Injectable({
  providedIn: 'root',
})
export class FlashSpreadState {

  @Selector()
  static documentsData(state: FlashSpreadStateModel) {
    return state?.documentsData ?? [];
  }

  @Selector()
  static businessTaxDocumentsData(state: FlashSpreadStateModel) {
    return state?.documentsData?.filter( doc => !!doc.forms?.find(form => form.type.includes('1120')));
  }

  @Selector()
  static personalTaxDocumentsData(state: FlashSpreadStateModel) {
    return state?.documentsData?.filter( doc => !!doc.forms?.find(form => form.type.includes('1040')));
  }

  constructor(
    private flashSpreadService: FlashSpreadService,
    private pusherService: PusherService,
    private store: Store,
  ) {}

  @Action(GetFlashSpreadData)
  GetFlashSpreadData(
    ctx: StateContext<FlashSpreadStateModel>,
    { borrowerId }: GetFlashSpreadData,
  ) {
    ctx.patchState({loading: true});
    return this.flashSpreadService.getFlashSpreadData(borrowerId)
      .pipe(
        catchError(err => {
          ctx.patchState({loading: false});
          throw err;
        }),
        tap(documentsData => {
          ctx.setState(patch({
            loading: false,
            documentsData,
          }));
        }),
      );
  }

  @Action(FlashSpreadPusherSubscribe)
  PusherSubscribe(
    ctx: StateContext<FlashSpreadStateModel>,
    { borrowerId }: FlashSpreadPusherSubscribe,
  ) {
    setTimeout(() => {
      if(ctx.getState().borrowerId !== borrowerId) {
        ctx.patchState({borrowerId});
        this.pusherService
          .subscribe(`pipeline-flash-spread-updates-${borrowerId}`)
          .bind_global(this.handlePusherEvent.bind(this, borrowerId));
      }
    });
  }

  @Action(ClearFlashSpreadState)
  ClearFlashSpreadState(
    ctx: StateContext<FlashSpreadStateModel>,
    { borrowerId }: ClearFlashSpreadState,
  ) {
    if(ctx.getState().borrowerId === borrowerId) {
      ctx.patchState({
        borrowerId: undefined,
        loading: false,
        documentsData: [],
      });
      this.pusherService.unsubscribe(`pipeline-flash-spread-updates-${borrowerId}`);
    }
  }

  handlePusherEvent(borrowerId: number, eventName: string, data: any) {
    if(get(data, 'status') === 'completed') {
      this.store.dispatch( new GetFlashSpreadData(borrowerId) );
    }
  }

}
